import React, { useContext } from 'react'

import Page from '../../components/Page'
import DistrictMetricsReport from '../../components/sections/reportBuilder/reports/DistrictMetricsReport'
import AuthContext from '../../utils/authProvider'

const DistrictMetricsReportPage = () => {
  const breadcrumb = [
    {
      path: '/',
      breadcrumbName: 'Home'
    },
    {
      path: '',
      breadcrumbName: 'District Metrics Report'
    }
  ]
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  return (
    <>
      <Page title='District Metrics Report' breadcrumb={breadcrumb}>
        <DistrictMetricsReport />
      </Page>
    </>
  )
}

export default DistrictMetricsReportPage
